module.exports = __webpack_public_path__ + "static/line1_12-dde5225da71ff24fea03d73fa295ccf9.jpg";